<template>
  <v-dialog
    v-bind="$attrs"
    :no-click-animation="draggable"
    :retain-focus="!draggable"
    :hide-overlay="draggable ? true : null"
    :content-class="`${contentClass} ${draggable ? 'draggable-dialog' : ''}`"
  >
    <div class="action-buttons-container" v-if="draggable">
      <v-icon v-if="draggable" class="draggable-icon">mdi-drag-variant</v-icon>
    </div>
    <slot />
  </v-dialog>
</template>

<script>
import {
  activateDraggableDialogs,
  deactivateDraggableDialogs
} from '@/utils/vuetify-multiple-draggable-dialogs'

export default {
  props: {
    contentClass: String,
    draggable: Boolean
  },

  watch: {
    isOpen() {
      if (this.draggable) {
        this.isOpen ? activateDraggableDialogs() : deactivateDraggableDialogs()
      }
    }
  },

  computed: {
    isOpen() {
      return this.$attrs.modelValue ?? this.$attrs.value
    }
  }
}
</script>

<style lang="scss">
.draggable-dialog {
  position: relative;
  .action-buttons-container {
    position: absolute;
    text-align: right;
    z-index: 1;
    padding: 18px;
    .draggable-icon {
      cursor: pointer;
    }
  }
}
</style>
